import auth from '../modules/auth'

export default {
  install(Vue) {
    Object.assign(Vue.prototype, { $auth: auth })
  },
}
